// import {
//   LOGIN_USER,
//   LOGIN_SUCCESS,
//   LOGOUT_USER,
//   LOGOUT_USER_SUCCESS,
//   API_ERROR,
// } from "./actionTypes"

// const initialState = {
//   error: "",
//   loading: false,
// }

// const login = (state = initialState, action) => {
//   switch (action.type) {
//     case LOGIN_USER:
//       state = {
//         ...state,
//         loading: true,
//       }
//       break
//     case LOGIN_SUCCESS:
//       state = {
//         ...state,
//         loading: false,
//         isUserLogout: false,
//       }
//       break
//     case LOGOUT_USER:
//       state = { ...state }
//       break
//     case LOGOUT_USER_SUCCESS:
//       state = { ...state , isUserLogout: true}
//       break
//     case API_ERROR:
//       state = { ...state, error: action.payload, loading: false,isUserLogout: false, }
//       break
//     default:
//       state = { ...state }
//       break
//   }
//   return state
// }

// export default login
// reducers/authReducer.js
// reducers/authReducer.js
import {
  LOGIN_SUCCESS,
  LOGIN_FAILURE,
  LOGOUT_USER,
  LOGOUT_USER_SUCCESS,
  LOGIN_REQUEST,
} from "./actionTypes";

const initialState = {
  token: null,
  menu: null,
  error: null,
  loading: false,
};

const authReducer = (state = initialState, action) => {
  switch (action.type) {
    case LOGIN_SUCCESS:
      return {
        ...state,
        token: action.payload.token,
        menu: action.payload.menu,
        error: null,
        loading: false,
        isUserLogout: false,
      };
    case LOGIN_REQUEST:
      return {
        ...state,
        loading: true,
      };
      break;
    case LOGIN_FAILURE:
      return {
        ...state,
        token: null,
        error: action.payload.error,
        loading: false,
      };
    case LOGOUT_USER:
      return {
        ...state,
        token: null,
        error: null,
        loading: false,
        isUserLogout: true,
      };
    case LOGOUT_USER_SUCCESS:
      return {
        ...state,
        token: null,
        error: null,
        loading: false,
        isUserLogout: true,
      };
    default:
      return state;
  }
};

export default authReducer;
